<template>
    <AlertDialog v-model:open="open">
        <AlertDialogContent>
            <AlertDialogHeader class="flex items-start flex-row space-y-0">
                <div
                    v-if="agreeButtonVariant === 'destructive'"
                    class="flex items-center shrink-0 justify-center mr-4 w-9 h-9 rounded-full bg-red-100"
                >
                    <ExclamationTriangleIcon class="h-4 w-4 text-red-500" />
                </div>
                <div>
                    <AlertDialogTitle class="text-base">{{ title }}</AlertDialogTitle>
                    <AlertDialogDescription v-html="message"></AlertDialogDescription>
                </div>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel @click="cancel">Cancel</AlertDialogCancel>
                <AlertDialogAction :variant="agreeButtonVariant" @click="agree">{{
                    agreeButtonText
                }}</AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>

<script setup>
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useDialogStore } from '@/stores/dialog'
import { ExclamationTriangleIcon } from '@radix-icons/vue'
import { storeToRefs } from 'pinia'

const dialogStore = useDialogStore()
const { cancel, agree } = dialogStore
const { open, title, message, agreeButtonText, agreeButtonVariant, width, zIndex } =
    storeToRefs(dialogStore)
</script>
